// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductItem_productItem__yi3vn {
  width: 100%;
  min-height: 108px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
@media (min-width: 640px) {
  .ProductItem_productItem__yi3vn {
    padding: 8px;
  }
}
.ProductItem_productItem__img__Y0zQk {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background: #FFF;
  width: 100%;
  min-height: 100px;
  max-height: 120px;
  height: 18vw;
}
@media (min-width: 480px) {
  .ProductItem_productItem__img__Y0zQk {
    height: 14vw;
  }
}
@media (min-width: 640px) {
  .ProductItem_productItem__img__Y0zQk {
    border-radius: 20px;
  }
}
.ProductItem_productItem__img__Y0zQk img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ProductItem_productItem__img__Y0zQk p {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 4px 12px;
  color: #FFF;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 114%;
  letter-spacing: -0.24px;
  border-radius: 0px 12px 12px 12px;
  background: rgba(0, 0, 0, 0.7);
}
@media (min-width: 640px) {
  .ProductItem_productItem__img__Y0zQk p {
    padding: 7px 18px;
    border-radius: 0px 16px 16px 12px;
    font-size: 16px;
    letter-spacing: -0.32px;
  }
}
.ProductItem_productItem__img_empty__s26iA {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #EDEDED;
  background: #F9F9F9;
  border-radius: 8px;
}
@media (min-width: 1200px) {
  .ProductItem_productItem__img_empty__s26iA {
    border-radius: 0;
    background: none;
    border: none;
  }
}
.ProductItem_productItem__img_empty__s26iA img {
  width: auto;
  height: auto;
}
.ProductItem_productItem__text__CRFuR {
  margin-top: 6px;
  text-align: center;
  width: 100%;
  font-weight: 600;
  line-height: 114%;
}
@media (min-width: 640px) {
  .ProductItem_productItem__text__CRFuR {
    margin-top: 9px;
    min-height: 44px;
    font-size: 18px;
  }
}
.ProductItem_productItem__textSk__KCH\\+4 {
  height: 14px;
  border-radius: 8px;
  width: 140px;
}
.ProductItem_productItem__ordered__-lv\\+q {
  position: absolute;
  top: -5px;
  right: -6px;
  padding: 3px 9px;
  border-radius: 12px;
  background: linear-gradient(90deg, #457CFA 0%, #984CF4 100%), #F7E14B;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 114%;
  color: #FAFAFA;
  z-index: 1;
}
@media (min-width: 640px) {
  .ProductItem_productItem__ordered__-lv\\+q {
    padding: 4px 12px;
    font-size: 16px;
    top: -8px;
    right: -4px;
  }
}

.ProductItem_productItemNew__dRuIY {
  display: flex;
  margin-bottom: 12px;
  width: 100%;
  position: relative;
  padding: 8px;
  background-color: var(--white);
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  border-radius: 12px;
  align-items: center;
  transition: var(--transition);
  transition-property: box-shadow;
}
@media (min-width: 1200px) {
  .ProductItem_productItemNew__dRuIY {
    min-height: 76px;
  }
}
@media (hover: hover) {
  .ProductItem_productItemNew__dRuIY:hover {
    box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.109803922);
  }
}
.ProductItem_productItemNew__img__E1lzW {
  max-height: 60px;
  max-width: 80px;
  width: auto;
  position: relative;
  margin-right: 10px;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__img__E1lzW {
    margin-right: 16px;
  }
}
@media (min-width: 1200px) {
  .ProductItem_productItemNew__img__E1lzW {
    min-width: auto;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
  }
}
.ProductItem_productItemNew__img__E1lzW img {
  width: 60px;
  height: 60px;
  object-position: center;
  object-fit: cover;
  border-radius: 8px;
}
@media (min-width: 1200px) {
  .ProductItem_productItemNew__img__E1lzW img {
    max-width: 100%;
    max-height: 100%;
    border: none;
  }
}
.ProductItem_productItemNew__time__fPd3h {
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  top: 8px;
  right: 8px;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__time__fPd3h {
    font-size: 14px;
    padding: 3px 12px;
  }
}
@media (min-width: 1200px) {
  .ProductItem_productItemNew__time__fPd3h {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.02em;
    min-height: 18px;
    padding: 2px 4px;
  }
}
.ProductItem_productItemNew__dRuIY .ProductItem_productItemNew__timeSk__QFQeD {
  position: absolute;
  height: 18px;
  border-radius: 8px;
  width: 70px;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__dRuIY .ProductItem_productItemNew__timeSk__QFQeD {
    height: 20px;
  }
}
.ProductItem_productItemNew__info__a73d3 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: calc(100% - 110px);
  width: 100%;
  gap: 4px;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__info__a73d3 {
    max-width: calc(100% - 146px);
  }
}
@media (min-width: 1200px) {
  .ProductItem_productItemNew__info__a73d3 {
    padding: 10px 0;
  }
}
.ProductItem_productItemNew__title__svcyV {
  font-size: 15px;
  font-weight: 600;
  line-height: 17px;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  max-width: calc(100% - 50px);
  color: #303030;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__title__svcyV {
    font-size: 17px;
    line-height: 21px;
  }
}
@media (min-width: 1200px) {
  .ProductItem_productItemNew__title__svcyV {
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
    margin: 0;
  }
}
.ProductItem_productItemNew__titleSk__\\+sd3f {
  height: 16px;
  border-radius: 8px;
  width: 140px;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__titleSk__\\+sd3f {
    height: 17px;
  }
}
.ProductItem_productItemNew__descr__t2N3C {
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  color: #7A808B;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__descr__t2N3C {
    font-size: 15px;
    line-height: 18px;
  }
}
@media (min-width: 1200px) {
  .ProductItem_productItemNew__descr__t2N3C {
    font-size: var(--fz-md);
    line-height: var(--lh-md);
  }
}
.ProductItem_productItemNew__descrSk__brjBM {
  height: 32px;
  border-radius: 8px;
  width: 100%;
}
@media (min-width: 640px) {
  .ProductItem_productItemNew__descrSk__brjBM {
    height: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProductItem/ProductItem.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EATF;IAUI,YAAA;EAEF;AACF;AAAE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AAEJ;AAAI;EAVF;IAWI,YAAA;EAGJ;AACF;AADI;EAdF;IAeI,mBAAA;EAIJ;AACF;AAFI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAIN;AADI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iCAAA;EACA,8BAAA;AAGN;AADM;EAdF;IAeI,iBAAA;IACA,iCAAA;IACA,eAAA;IACA,uBAAA;EAIN;AACF;AADI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAGN;AADM;EARF;IASI,gBAAA;IACA,gBAAA;IACA,YAAA;EAIN;AACF;AAFM;EACE,WAAA;EACA,YAAA;AAIR;AACE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AACI;EAPF;IAQI,eAAA;IACA,gBAAA;IACA,eAAA;EAEJ;AACF;AACE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;AACJ;AAEE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qEAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAAJ;AAEI;EAdF;IAeI,iBAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;EACJ;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,uDAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,+BAAA;AAAF;AAEE;EAbF;IAcI,gBAAA;EACF;AACF;AACE;EACE;IACE,sDAAA;EACJ;AACF;AAEE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AAEI;EAPF;IAQI,kBAAA;EACJ;AACF;AACI;EAXF;IAYI,eAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;EAEJ;AACF;AAAI;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAEN;AAAM;EAPF;IAQI,eAAA;IACA,gBAAA;IACA,YAAA;EAGN;AACF;AACE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AACJ;AACI;EARF;IASI,eAAA;IACA,iBAAA;EAEJ;AACF;AAAI;EAbF;IAcI,kBAAA;IACA,QAAA;IACA,UAAA;IACA,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;EAGJ;AACF;AAAE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAEJ;AAAI;EANF;IAOI,YAAA;EAGJ;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,WAAA;EACA,QAAA;AAEJ;AAAI;EARF;IASI,6BAAA;EAGJ;AACF;AADI;EAZF;IAaI,eAAA;EAIJ;AACF;AADE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAGJ;AADI;EAdF;IAeI,eAAA;IACA,iBAAA;EAIJ;AACF;AAFI;EAnBF;IAoBI,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,SAAA;EAKJ;AACF;AAFE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;AAIJ;AAFI;EALF;IAMI,YAAA;EAKJ;AACF;AAFE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAIJ;AAFI;EAZF;IAaI,eAAA;IACA,iBAAA;EAKJ;AACF;AAHI;EAjBF;IAkBI,uBAAA;IACA,yBAAA;EAMJ;AACF;AAHE;EACE,YAAA;EACA,kBAAA;EACA,WAAA;AAKJ;AAHI;EALF;IAMI,YAAA;EAMJ;AACF","sourcesContent":[".productItem {\n  width: 100%;\n  min-height: 108px;\n  padding: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n\n  @media (min-width: 640px) {\n    padding: 8px;\n  }\n\n  &__img {\n    position: relative;\n    overflow: hidden;\n    border-radius: 12px;\n    background: #FFF;\n    width: 100%;\n    min-height: 100px;\n    max-height: 120px;\n    height: 18vw;\n\n    @media (min-width: 480px) {\n      height: 14vw;\n    }\n\n    @media (min-width: 640px) {\n      border-radius: 20px;\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    p {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      padding: 4px 12px;\n      color: #FFF;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 114%;\n      letter-spacing: -0.24px;\n      border-radius: 0px 12px 12px 12px;\n      background: rgba(0, 0, 0, 0.70);\n\n      @media (min-width: 640px) {\n        padding: 7px 18px;\n        border-radius: 0px 16px 16px 12px;\n        font-size: 16px;\n        letter-spacing: -0.32px;\n      }\n    }\n\n    &_empty {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: 1px solid #EDEDED;\n      background: #F9F9F9;\n      border-radius: 8px;\n\n      @media (min-width: 1200px) {\n        border-radius: 0;\n        background: none;\n        border: none;\n      }\n\n      img {\n        width: auto;\n        height: auto;\n      }\n    }\n  }\n\n  &__text {\n    margin-top: 6px;\n    text-align: center;\n    width: 100%;\n    font-weight: 600;\n    line-height: 114%;\n\n    @media (min-width: 640px) {\n      margin-top: 9px;\n      min-height: 44px;\n      font-size: 18px;\n    }\n  }\n\n  &__textSk {\n    height: 14px;\n    border-radius: 8px;\n    width: 140px;\n  }\n\n  &__ordered {\n    position: absolute;\n    top: -5px;\n    right: -6px;\n    padding: 3px 9px;\n    border-radius: 12px;\n    background: linear-gradient(90deg, #457CFA 0%, #984CF4 100%), #F7E14B;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 114%;\n    color: #FAFAFA;\n    z-index: 1;\n\n    @media (min-width: 640px) {\n      padding: 4px 12px;\n      font-size: 16px;\n      top: -8px;\n      right: -4px;\n    }\n  }\n}\n\n.productItemNew {\n  display: flex;\n  margin-bottom: 12px;\n  width: 100%;\n  position: relative;\n  padding: 8px;\n  background-color: var(--white);\n  box-shadow: 0px 5px 9px 0px #0000000D;\n  border-radius: 12px;\n  align-items: center;\n  transition: var(--transition);\n  transition-property: box-shadow;\n\n  @media (min-width: 1200px) {\n    min-height: 76px;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.109803922)\n    }\n  }\n\n  &__img {\n    max-height: 60px;\n    max-width: 80px;\n    width: auto;\n    position: relative;\n    margin-right: 10px;\n\n    @media (min-width: 640px) {\n      margin-right: 16px;\n    }\n\n    @media (min-width: 1200px) {\n      min-width: auto;\n      flex-shrink: 0;\n      width: 60px;\n      height: 60px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-right: 24px;\n    }\n\n    img {\n      width: 60px;\n      height: 60px;\n      object-position: center;\n      object-fit: cover;\n      border-radius: 8px;\n\n      @media (min-width: 1200px) {\n        max-width: 100%;\n        max-height: 100%;\n        border: none;\n      }\n    }\n  }\n\n  &__time {\n    padding: 2px 10px;\n    font-size: 12px;\n    font-weight: 500;\n    position: absolute;\n    top: 8px;\n    right: 8px;\n\n    @media (min-width: 640px) {\n      font-size: 14px;\n      padding: 3px 12px;\n    }\n\n    @media (min-width: 1200px) {\n      position: absolute;\n      top: 8px;\n      right: 8px;\n      font-size: 12px;\n      line-height: 14px;\n      letter-spacing: -0.02em;\n      min-height: 18px;\n      padding: 2px 4px;\n    }\n  }\n\n  .productItemNew__timeSk {\n    position: absolute;\n    height: 18px;\n    border-radius: 8px;\n    width: 70px;\n\n    @media (min-width: 640px) {\n      height: 20px;\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: calc(100% - 110px);\n    width: 100%;\n    gap: 4px;\n\n    @media (min-width: 640px) {\n      max-width: calc(100% - 146px);\n    }\n\n    @media (min-width: 1200px) {\n      padding: 10px 0;\n    }\n  }\n\n  &__title {\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 17px;\n    text-align: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 100%;\n    max-width: calc(100% - 50px);\n    color: #303030;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    @media (min-width: 640px) {\n      font-size: 17px;\n      line-height: 21px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: 16px;\n      line-height: 20px;\n      font-weight: normal;\n      margin: 0;\n    }\n  }\n\n  &__titleSk {\n    height: 16px;\n    border-radius: 8px;\n    width: 140px;\n\n    @media (min-width: 640px) {\n      height: 17px;\n    }\n  }\n\n  &__descr {\n    font-size: 13px;\n    line-height: 16px;\n    font-weight: 400;\n    color: #7A808B;\n    text-align: left;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media (min-width: 640px) {\n      font-size: 15px;\n      line-height: 18px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-md);\n      line-height: var(--lh-md);\n    }\n  }\n\n  &__descrSk {\n    height: 32px;\n    border-radius: 8px;\n    width: 100%;\n\n    @media (min-width: 640px) {\n      height: 36px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productItem": `ProductItem_productItem__yi3vn`,
	"productItem__img": `ProductItem_productItem__img__Y0zQk`,
	"productItem__img_empty": `ProductItem_productItem__img_empty__s26iA`,
	"productItem__text": `ProductItem_productItem__text__CRFuR`,
	"productItem__textSk": `ProductItem_productItem__textSk__KCH+4`,
	"productItem__ordered": `ProductItem_productItem__ordered__-lv+q`,
	"productItemNew": `ProductItem_productItemNew__dRuIY`,
	"productItemNew__img": `ProductItem_productItemNew__img__E1lzW`,
	"productItemNew__time": `ProductItem_productItemNew__time__fPd3h`,
	"productItemNew__timeSk": `ProductItem_productItemNew__timeSk__QFQeD`,
	"productItemNew__info": `ProductItem_productItemNew__info__a73d3`,
	"productItemNew__title": `ProductItem_productItemNew__title__svcyV`,
	"productItemNew__titleSk": `ProductItem_productItemNew__titleSk__+sd3f`,
	"productItemNew__descr": `ProductItem_productItemNew__descr__t2N3C`,
	"productItemNew__descrSk": `ProductItem_productItemNew__descrSk__brjBM`
};
export default ___CSS_LOADER_EXPORT___;
